<template>
  <div class="focus-delete">
    <v-btn icon @click="confirm = true" color="red">
      <v-icon>mdi-delete</v-icon>
    </v-btn>
    <Confirm @close="confirm = false" @click="submit" v-if="confirm"></Confirm>
  </div>
</template>

<script>
import { db } from "../assets/js/firebase";
import Confirm from "../components/Confirm";
export default {
  props: {
    item: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  components: {
    Confirm
  },
  data() {
    return {
      confirm: false
    };
  },
  computed: {
    loader: {
      set(val) {
        this.$root.loader = val;
      },
      get() {
        return false;
      }
    },
    alert: {
      set(val) {
        this.$root.alert(val);
      },
      get() {
        return false;
      }
    }
  },
  methods: {
    async submit() {
      const vm = this;
      vm.confirm = false;
      let { key } = vm.item;
      try {
        vm.loader = true;
        await db
          .child("property")
          .child(key)
          .remove();
        vm.alert = "Property Address Removed Successfully!";
        vm.loader = false;
      } catch ({ message }) {
        vm.loader = false;
        vm.alert = message;
      }
    }
  }
};
</script>

<style>
.focus-delete {
  float: left;
}
</style>
